import Select from 'react-select';

function YearsList({ value, handleChange }) {
  const __start = 1990;
  const __end = new Date().getFullYear();

  const __options = [];

  for (let index = __start; index < __end; index++) {
    __options.push({ value: index, label: index });
  }

  return (
    <>
      <label>Year</label>
      <Select
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
        }}
        isClearable={false}
        isSearchable={false}
        className="basic-single"
        classNamePrefix="select"
        name="mcqOptionsDq"
        options={__options}
        value={__options.find?.((x) => x.value === value)}
        onChange={(args) => {
          const askedInYear = args.value;
          handleChange({ askedInYear });
        }}
      />
      {/* <select
        value={value}
        onChange={(event) => {
          const askedInYear = event.target.value;
          handleChange({ askedInYear }, event);
        }}
      >
        <option value="">Select</option>
        {__options}
      </select> */}
    </>
  );
}

YearsList.defaultProps = {
  handleChange: () => {},
};

export default YearsList;
